import { SvgIcon } from '@mui/material';
import React, { ReactElement } from 'react';

export interface SearchIconProps {}

export const SearchIcon = ({}: SearchIconProps): ReactElement => {
  return (
    <SvgIcon style={{ fontSize: '1em' }} viewBox="0 0 19.06 18.98">
      <g id="search" transform="translate(1 0.984)">
        <g id="Group_374" data-name="Group 374" transform="translate(0 0.016)">
          <path
            fill="currentColor"
            stroke="none"
            d="M16.877,16.378l-5.166-5.166a6.758,6.758,0,1,0-.5.5l5.166,5.166a.354.354,0,1,0,.5-.5ZM6.721,12.737a6.014,6.014,0,1,1,6.014-6.014A6.02,6.02,0,0,1,6.721,12.737Z"
            transform="translate(0 -0.002)"
          />
        </g>
      </g>
    </SvgIcon>
  );
};
